import Action from './Action'
import './Action.sass'

export default Action
